import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const RecentMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Lavender500};
`
